import {Button as MButton} from '@material-ui/core';
import React from 'react';
import {Link} from 'react-router-dom';
import './button.css';

const ButtonComponent = React.forwardRef<any, any>((props, ref) => {
  // TODO checar se o link vai funcionar
  if (props.to) {
    return <Link to={props.to} {...props} ref={ref} />;
  }

  return <button type="button" {...props} ref={ref} />;
});

const Button = ({children, className, onClick, to, ...props}: any) => {
  return (
    <MButton
      className={`button-default ${className || ''}${to ? ' anchor-btn' : ''}`}
      onClick={onClick}
      to={to}
      {...props}
      variant="contained"
      component={ButtonComponent}
    >
      {children}
    </MButton>
  );
};

// Button.propTypes = {
//   children: PropTypes.oneOfType([
//     PropTypes.node,
//     PropTypes.arrayOf(PropTypes.node),
//   ]).isRequired,
//   className: PropTypes.string,
//   onClick: PropTypes.func,
//   to: PropTypes.string,
// };
//
// Button.defaultProps = {
//   className: '',
//   onClick: null,
//   to: null,
// };

export default Button;



// WEBPACK FOOTER //
// ./src/shared/components/buttons/Button.tsx